import { useLanguageContext, Language } from "../contexts/LanguageContext";

export type { Language };

export default function useLanguage(): [Language, (lang: Language) => void] {
  const { language, setLanguage } = useLanguageContext();
  return [language, setLanguage];
}

